import { CheckboxState } from '../../../common/components/checkboxes/CheckboxState';
import { SiteRoles } from '../../../ts/ServerApi/types/ISiteRole';
import { SiteRoleOptionsResource } from '../../services/resources/SiteRoleOptions';
import { UserRoleSelections } from '../EditSiteMembershipDialog';
import { SiteRoleCheckboxPropsDictionary, SiteRoleSelectorPropsDictionary, SiteRolesPickerContainerState } from '../SiteRolesPickerContainer';
import { SiteRolesPickerDataGridHelper } from './SiteRolesPickerDataGridHelper';


const ADMIN_SITE_ROLE_OPTION = SiteRoles.ServerAdministrator;

export class SiteRolesPickerAdminCheckboxHelper {
    /**
     * 
     * @param state 
     * @param siteRolesResource 
     * CheckboxProps changed to checked and Dropdown Props to ServerAdmin with both being disabled, saving previous state
     */
    public static getStateWhenChecked(state: SiteRolesPickerContainerState, siteRolesResource: SiteRoleOptionsResource, userRoleSelections: UserRoleSelections): SiteRolesPickerContainerState {
        let siteRowCheckboxPropMapBackup;
        let siteRowDropdownPropMapBackup;

        if (state.adminCheckboxState !== CheckboxState.mixed) {
            siteRowCheckboxPropMapBackup = state.siteRowCheckboxPropMap;
            siteRowDropdownPropMapBackup = state.siteRowDropdownPropMap;
        } else {
            let newState = SiteRolesPickerAdminCheckboxHelper.getStateWhenTransitionFromMixed(state, userRoleSelections, siteRolesResource);
            siteRowCheckboxPropMapBackup = newState.siteRowCheckboxPropMap;
            siteRowDropdownPropMapBackup = newState.siteRowDropdownPropMap;
        }

        let siteRowCheckboxPropMap: SiteRoleCheckboxPropsDictionary = {};
        let siteRowDropdownPropMap: SiteRoleSelectorPropsDictionary = {};
        for (let prop in siteRowCheckboxPropMapBackup) {
            let disabled = true;
            let checkboxState = CheckboxState.checked;
            siteRowCheckboxPropMap[prop] = {...siteRowCheckboxPropMapBackup[prop], checkboxState, disabled};
        }
        for (let prop in siteRowDropdownPropMapBackup) {
            let isDisabled = true;
            let selectedRole = siteRolesResource.getSiteRoleOptionBySiteRole(ADMIN_SITE_ROLE_OPTION);
            let siteRoleOptions = siteRolesResource.getAllSiteRoleOptions();
            siteRowDropdownPropMap[prop] = {...siteRowDropdownPropMapBackup[prop], isDisabled, selectedRole, siteRoleOptions};
        }
        return {...state, adminCheckboxState: CheckboxState.checked, siteRowCheckboxPropMapBackup, siteRowDropdownPropMapBackup, siteRowCheckboxPropMap, siteRowDropdownPropMap};
    }

    /**
     * @param state
     * Checkbox and Dropdown props return to previous state
     */
    public static getStateWhenEmpty(state: SiteRolesPickerContainerState, userRoleSelections: UserRoleSelections, siteRolesResource: SiteRoleOptionsResource): SiteRolesPickerContainerState {
        let siteRowCheckboxPropMap = state.siteRowCheckboxPropMapBackup;
        let siteRowDropdownPropMap = state.siteRowDropdownPropMapBackup;
        if (state.siteRowCheckboxPropMapBackup === null || state.siteRowDropdownPropMapBackup === null) {
            let newState = SiteRolesPickerAdminCheckboxHelper.getStateWhenTransitionFromMixed(state, userRoleSelections, siteRolesResource);
            siteRowCheckboxPropMap = newState.siteRowCheckboxPropMap;
            siteRowDropdownPropMap = newState.siteRowDropdownPropMap;
        }
        return {...state,  adminCheckboxState: CheckboxState.empty, siteRowCheckboxPropMap, siteRowDropdownPropMap};
    }

    public static getStateWhenTransitionFromMixed(state: SiteRolesPickerContainerState, userRoleSelections: UserRoleSelections, siteRolesResource: SiteRoleOptionsResource): SiteRolesPickerContainerState {
        let siteRowCheckboxPropMap: SiteRoleCheckboxPropsDictionary = {};
        let siteRowDropdownPropMap: SiteRoleSelectorPropsDictionary = {};

        for (let prop in state.siteRowCheckboxPropMap) {
            siteRowCheckboxPropMap[prop] = SiteRolesPickerDataGridHelper.getRowCheckboxPropsOnModify(userRoleSelections, prop, siteRowCheckboxPropMap, state);
        }

        for (let prop in state.siteRowDropdownPropMap) {
            siteRowDropdownPropMap[prop] = SiteRolesPickerDataGridHelper.getRowDropdownPropsOnModify(userRoleSelections, prop, siteRowDropdownPropMap, state, siteRolesResource);
        }
        return {...state, siteRowCheckboxPropMap, siteRowDropdownPropMap};
    }
  }
